module.exports = __webpack_public_path__ + "static/media/instagram.ef122d78.svg";